//import { PnkAjax } from '../api/pnk-ajax';
import { PnkAjax } from '../pnk-react/ajax/pnk-ajax';

export function AddNewAgreement(store, data, token, SuccessCallBackFunc) {
  let loader = { isLoader: false, containerId: 'testpnk', size: 'small' };
  return PnkAjax(store).Post('agreements/new.json').ExtraData(data).AttachLoader(loader).AddHeader({ 'x-access-token': token }).OnSuccess(SuccessCallBackFunc).Do();
}
export function UpdateAgreement(store, data, token, SuccessCallBackFunc) {
  let loader = { isLoader: false, containerId: 'testpnk', size: 'small' };
  return PnkAjax(store).Put('agreements/update.json').ExtraData(data).AttachLoader(loader).AddHeader({ 'x-access-token': token }).OnSuccess(SuccessCallBackFunc).Do();
}
export function GetAllAgreement(store, data, token, SuccessCallBackFunc) {
  let loader = { isLoader: false, containerId: 'testpnk', size: 'small' };
  return PnkAjax(store).Post('agreements/search.json').ExtraData(data).AttachLoader(loader).AddHeader({ 'x-access-token': token }).OnSuccess(SuccessCallBackFunc).Do();
}
export function DownloadAgreement(store, data, token, SuccessCallBackFunc) {
  let loader = { isLoader: false, containerId: 'testpnk', size: 'small' };
  return PnkAjax(store).Post('agreements/download.json').ExtraData(data).AttachLoader(loader).AddHeader({ 'x-access-token': token }).OnSuccess(SuccessCallBackFunc).Do();
}


